<template>
  <div>
    <ts-dialog :visible.sync="visible" center :no-header="true" width="1000px" top="20px" :show-close="false">
      <template #title>
        <ts-toolbar>
          <div class="toolbar">
            <div class="filename">
              {{ file.name }}
            </div>
            <div class="actions">
              <ts-button v-show="canDownload" size="small" type="primary" filled @click="handleDownloadClick">
                Download
              </ts-button>
              <ts-button v-if="showEdit" size="small" circle @click="handleEditClick">
                <ts-icon icon="pen" size="x-small" color="#6d7587" />
              </ts-button>
              <ts-button v-if="showDelete" size="small" circle @click="handleDeleteClick">
                <ts-icon icon="trash" size="x-small" color="#6d7587" />
              </ts-button>
            </div>
          </div>
        </ts-toolbar>
      </template>
      <div class="content">
        <img v-if="isImage" class="image-preview" :src="file.url" />
        <pdf v-if="isPdf" :src="file.url"></pdf>
      </div>
    </ts-dialog>
    <ts-button size="small" circle @click="handleViewClick">
      <ts-icon icon="eye" size="x-small" color="#6d7587" />
    </ts-button>
  </div>
</template>

<style lang="scss" scoped>
.toolbar {
  display: flex;
  align-items: center;

  .filename {
    flex-grow: 1;

    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
    text-align: left;
  }

  .actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview {
  width: 100%;
}
</style>

<script>
import pdf from 'vue-pdf';

const KNOWN_IMAGE_TYPES = ['jpg', 'jpeg', 'png'];

export default {
  components: {
    pdf
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    canDownload() {
      return this.file?.status === 'processed';
    },
    isImage() {
      return KNOWN_IMAGE_TYPES.includes(this.file.name?.split('.')?.pop()?.toLowerCase());
    },
    isPdf() {
      return this.file.name?.split('.')?.pop()?.toLowerCase() === 'pdf';
    }
  },
  methods: {
    handleViewClick() {
      this.visible = true;
    },
    handleDownloadClick() {
      window.open(this.file.url, '_blank');
    },
    handleEditClick() {
      this.$emit('edit');
      this.visible = false;
    },
    handleDeleteClick() {
      this.$emit('delete');
      this.visible = false;
    }
  }
};
</script>
